import config from '../../config';
import { request } from '../../libraries/request'

const getAll = (params = {}, token) => {
  console.log('SERVICES::PRODUCT_VARIANTS::getAll', params, token);
  if (params?.page_num && config.QUERIES_PAGE_SIZE) {
    params.page_size = config.QUERIES_PAGE_SIZE;
  }
  if (!params.order_by) { 
    params.order_by = 'title';
    params.order_direction = 'ASC';
  }

  return request({
    url: `${config.BASE_API_URL}${config.API.PRODUCTS}/${params.productID}/variants`,
    accessToken: token,
    // data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }
    return response;
  })
}

const save = (data, token, id) => {
  console.log('SERVICES::PRODUCT_VARIANTS::save', data, token, id);
  return request({
    url: `${config.BASE_API_URL}${config.API.PRODUCTS}/${id}/variants`,
    accessToken: token,
    method: 'POST',
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const update = (data, token) => {
  console.log('SERVICES::PRODUCT_VARIANTS::update', data, token);
  console.warn('PATCH FUNCTIONALITY NOT DEVELOPED')
  return;
  /* return request({
    url: config.BASE_API_URL + config.API.PRODUCT.replace('{id}', data.id),
    accessToken: token,
    method: 'PATCH',
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  }) */
}

const get = (id, token, data) => {
  console.log('SERVICES::PRODUCT_VARIANTS::get', id, data, token);
  return request({
    url: `${config.BASE_API_URL}${config.API.PRODUCTS}/${id}/variants`,
    accessToken: token,
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })

}

const del = (id, token, variantID) => {
  console.log('SERVICES::PRODUCT_VARIANTS::remove', id, token);
  return request({
    url: `${config.BASE_API_URL}${config.API.PRODUCTS}/${id}/variants/${variantID}`,
    accessToken: token,
    method: 'DELETE',
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const services = {
  getAll,
  save,
  get,
  del,
  update,
};

export default services;